import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    request?: any;
    data?: any;
    body: GeneralResponseBody;
}

export interface CurrencySchema {
    id: string;
    code: string;
    name: string;
    isDefault: boolean;
    symbol: string;
    symbolSeparated: string;
}

export interface GeneralResponseBody {
    data: Array<CurrencySchema>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}

export const fetchCurrencies = createAction<fetchCurrenciesAction | undefined>(
    ActionTypes.FETCH_CURRENCIES,
);
export const fetchCurrenciesSuccess =
    createAction<fetchCurrenciesSuccessAction>(
        ActionTypes.FETCH_CURRENCIES_SUCCESS,
    );
export const fetchCurrenciesFailed = createAction<fetchCurrenciesFailedAction>(
    ActionTypes.FETCH_CURRENCIES_FAILED,
);

export interface fetchCurrenciesAction {
    type: typeof ActionTypes.FETCH_CURRENCIES;
}

export interface fetchCurrenciesSuccessAction {
    type: typeof ActionTypes.FETCH_CURRENCIES_SUCCESS;
    payload: GeneralResponse;
}

export interface fetchCurrenciesFailedAction {
    type: typeof ActionTypes.FETCH_CURRENCIES_FAILED;
}
